module.exports = __webpack_public_path__ + "img/fashion_20.01215ca3.jpg";